// Generated by scripts/generate-public-surface.ts. Do not edit.

import type { CountryValidator } from "../../types";

import {
  createValidator,
  getBinding,
} from "#stdnum-runtime";

const sedol: CountryValidator<"GB"> = createValidator(
  "gb.sedol",
  81,
);

export default sedol;
export const compact = sedol.compact;
export const format = sedol.format;
export const validate = sedol.validate;
export const generate = (): string =>
  sedol.generate?.() ??
  (() => {
    throw new Error(
      "Validator gb.sedol cannot generate values",
    );
  })();
export const calcCheckDigit = (value: string): string =>
  getBinding().gbSedolCalcCheckDigit(value);
